<template lang="pug">
.v-main-filter.main-filter(v-if="data")
	.main-filter__tabs
		v-field(:field="data" :model-value="data.value" @update:model-value="requestDataLoad")

	.main-filter__block(v-if="data.fields")
		.main-filter__item(v-for="(field, index) in data.fields" :key="index" :style="{width: field.width || null}")
			template(v-if="field.type === 'range'" )
				v-price-ranger(:field="field" :model-value="field.value" @update:model-value="updateFilters(field, $event)")
			template(v-else )
				v-field(:field="field" :model-value="field.value" @update:model-value="updateFilters(field, $event)" @map-filter-changed="sendMapFilter")

	.main-filter__buttons(v-if="data.links" )
		a.main-filter__button(v-for="(link, index) in data.links"
			:key="index"
			:href="link.href"
			:class="link.className")
			.main-filter__button-text(v-if="link.text" ) {{ link.text }}
			v-svg-icon.main-filter__button-icon(v-if="link.icon" :icon="link.icon")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'
export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			localValue: null,
			tabName: null,
			filter: {},
			area: null
		};
	},

	watch: {
		tabName() {
			// this.localValue = null;
			// this.filter = null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.tabName = data.value;
			this.filter = this.initFilter()
		},

		initFilter() {
			let result = {};
			this.data.fields.forEach(field => {
				result[[`filter[${field.name}]`]] = field.value
			})
			return {...this.filter, ...result}
		},

		requestDataLoad(value) {
			this.tabName = value;
			this.dataLoad({
				url: this.data.remote,
				data: {[`tab[${this.data.name}]`]: value},
				delay: true
			})
		},

		updateFilters(field, value) {
			this.localValue = {...this.localValue, ...{[`filter[${field.name}]`]: value}, ...{[`tab[${this.data.name}]`]: this.tabName}}

			this.filter = {...this.filter, [`filter[${field.name}]`]: value}

			this.dataLoad({
				url: this.data.remote,
				data: {
					...this.localValue,
					mapFilter: this.area,
				},
				delay: true
			})
		},

		sendMapFilter(area) {
			this.area = area
			this.dataLoad({
				url: this.data.remote,
				delay: true,
				data: {
					...{[`tab[${this.data.name}]`]: this.tabName},
					...this.filter,
					mapFilter: area,
					action: 'drawing'
				},
			})
		}
	}
};
</script>